<template>
  <div class="flex flex-col gap-2 pb-2">
    <InputRadio v-for="option in options" :key="option.id"
      :id="option.id" :name="option.name" :value="option.value"
      :label="option.label" :model-value="newComponentStore.newComponent.type"
      @update:model-value="selectType(option.value)"
      :description="option.description" />
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import { CumulInterval, SalesReportSettingsType } from '../../SalesReport'
import { useNewComponentStore } from '../../stores/newComponentStore'
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
import InputRadio from './input/InputRadio.vue'

const props = withDefaults(defineProps<{
  excludeTypes?: SalesReportSettingsType[]
}>(), {
  excludeTypes: () => []
})

const newComponentStore = useNewComponentStore();

const allOptions = [
  {
    id: 'daily',
    name: 'type',
    value: 'daily' as SalesReportSettingsType,
    label: t('newcomponent.type.daily'),
    description: t('newcomponent.type.daily_description')
  },
  {
    id: 'weekly',
    name: 'type',
    value: 'weekly' as SalesReportSettingsType,
    label: t('newcomponent.type.weekly'),
    description: t('newcomponent.type.weekly_description')
  },
  {
    id: 'monthly',
    name: 'type',
    value: 'monthly' as SalesReportSettingsType,
    label: t('newcomponent.type.monthly'),
    description: t('newcomponent.type.monthly_description')
  },
  {
    id: 'yearly',
    name: 'type',
    value: 'yearly' as SalesReportSettingsType,
    label: t('newcomponent.type.yearly'),
    description: t('newcomponent.type.yearly_description')
  },
  {
    id: 'custom',
    name: 'type',
    value: 'custom' as SalesReportSettingsType,
    label: t('newcomponent.type.custom'),
    description: t('newcomponent.type.custom_description')
  }
]

const options = computed(() => allOptions.filter(o => !props.excludeTypes.includes(o.value)))

const interval: Record<SalesReportSettingsType, CumulInterval> = {
  daily: 'day',
  weekly: 'day',
  monthly: 'day',
  yearly: 'month',
  custom: 'day'
}

const selectType = (type: SalesReportSettingsType) => {
  newComponentStore.newComponent.type = type
  newComponentStore.newComponent.interval = interval[type]
}
</script>